<template>
  <div class="thumbs-up">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="127.323"
      height="118.448"
      viewBox="0 0 127.323 118.448"
    >
      <g id="Thumbs_Up" transform="translate(-931.985 551.729)">
        <path
          id="Path_1633"
          data-name="Path 1633"
          d="M1042.461-454.91a5.643,5.643,0,0,0-2.794-1.209c-.509-.073-13.742-2.42-18.816-3.321a2.5,2.5,0,0,1-1.961-1.26,2.784,2.784,0,0,1-.04-2.386l5.212-13.423a11.548,11.548,0,0,0,.946-4.806,7.748,7.748,0,0,0-5.351-7.541.986.986,0,0,0-1.195.678l-1.613,5.542a7.1,7.1,0,0,1-1.014,2.021l-12.642,18.808c-3.355,5.138-8.8,8.331-14.2,8.331h-7.7v-1.976h-5.021v-1.2h-20.5v38.6h20.5v-2.3h5.021v-3.93h7.1a11.844,11.844,0,0,1,1.539.1,11.876,11.876,0,0,1,4.108,1.416l4.791,2.61a16.381,16.381,0,0,0,7.333,1.742h18.151a13.838,13.838,0,0,0,3.752-.518l4.3-1.214a5.316,5.316,0,0,0,4.234-5.193v-1.383c0-.026-.01-.049-.011-.075a5.3,5.3,0,0,0,4.028-5.14,5.281,5.281,0,0,0-1.488-3.674,5.654,5.654,0,0,0,3.721-5.3,5.629,5.629,0,0,0-1.8-4.127,5.627,5.627,0,0,0,1.414-.817,5.382,5.382,0,0,0,2.016-4.189v-.993A4.759,4.759,0,0,0,1042.461-454.91ZM968.2-423.348a2.681,2.681,0,0,1-2.681-2.68,2.682,2.682,0,0,1,2.681-2.681,2.682,2.682,0,0,1,2.681,2.681A2.681,2.681,0,0,1,968.2-423.348Zm11.126.161a.865.865,0,0,1-.865.864h-1.323a.865.865,0,0,1-.864-.864v-29.429a.865.865,0,0,1,.864-.865h1.323a.865.865,0,0,1,.865.865Zm63.183-26.863a3.422,3.422,0,0,1-1.286,2.659,3.74,3.74,0,0,1-2.35.824h-5.217a4.078,4.078,0,0,1-2.813-1.124.985.985,0,0,0-1.392.023.985.985,0,0,0,.023,1.392,5.981,5.981,0,0,0,4.182,1.677h3.384a3.792,3.792,0,0,1,3.826,3.312,3.684,3.684,0,0,1-3.662,4.048h-1.8c-.027,0-.053,0-.08,0h-4.9a.985.985,0,0,0-.984.985.985.985,0,0,0,.984.985h.779c.008,0,.014,0,.02,0h4.143a3.333,3.333,0,0,1,3.274,3.672,3.432,3.432,0,0,1-3.461,2.987h-4.889a.985.985,0,0,0-.985.985.985.985,0,0,0,.985.985h4.349v1.3a3.366,3.366,0,0,1-2.729,3.28l-4.368,1.231a11.875,11.875,0,0,1-3.218.445h-18.151a14.373,14.373,0,0,1-6.418-1.517l-4.763-2.595a13.832,13.832,0,0,0-4.794-1.639,13.928,13.928,0,0,0-1.795-.117H982.37a1.077,1.077,0,0,1-1.077-1.077v-23.1a1.078,1.078,0,0,1,1.077-1.077H989c6.06,0,12.133-3.534,15.84-9.213l12.618-18.771a9.008,9.008,0,0,0,1.28-2.575l1.311-4.5a5.864,5.864,0,0,1,2.993,5.307,9.629,9.629,0,0,1-.8,4.014l-5.191,13.378a4.7,4.7,0,0,0,.1,4.084,4.378,4.378,0,0,0,3.378,2.286c1.873.333,18.315,3.253,18.875,3.33a3.669,3.669,0,0,1,1.82.788,2.827,2.827,0,0,1,1.287,2.336Z"
          transform="translate(-5.765 -15.232)"
          fill="#fff"
        />
        <path
          id="Line_1"
          d="M995.159-516.294a1.1,1.1,0,0,0-.049-.323l-7.037-22.642a1.089,1.089,0,0,0-1.362-.717,1.086,1.086,0,0,0-.717,1.363l7.037,22.642a1.088,1.088,0,0,0,1.362.717A1.09,1.09,0,0,0,995.159-516.294Z"
          transform="translate(-13.08 -2.837)"
          fill="#fff"
          class="animate--sparkle"
        />
        <path
          id="Line_2"
          d="M1014.578-550.64v30.589a1.088,1.088,0,0,0,1.088,1.089,1.088,1.088,0,0,0,1.089-1.089V-550.64a1.088,1.088,0,0,0-1.089-1.089A1.088,1.088,0,0,0,1014.578-550.64Z"
          transform="translate(-20.02)"
          fill="#fff"
          class="animate--sparkle"
          style="animation-delay: 250ms;"
        />
        <path
          id="Line_3"
          d="M1041.007-539.259l-7.037,22.642a1.082,1.082,0,0,0,.716,1.363,1.089,1.089,0,0,0,1.363-.717l7.037-22.642a1.119,1.119,0,0,0,.048-.323,1.09,1.09,0,0,0-.765-1.04A1.089,1.089,0,0,0,1041.007-539.259Z"
          transform="translate(-24.708 -2.837)"
          fill="#fff"
          class="animate--sparkle"
          style="animation-delay: 500ms;"
        />
        <g id="Left_Stars" transform="translate(931.985 -517.399)">
          <path
            id="Left_Stars_2"
            d="M948.93-485.109h1.646a1.63,1.63,0,0,1,1.63,1.63v1.646a1.1,1.1,0,0,0,1.095,1.095,1.1,1.1,0,0,0,1.095-1.095v-1.646a1.63,1.63,0,0,1,1.63-1.63h1.646a1.094,1.094,0,0,0,1.094-1.095,1.094,1.094,0,0,0-1.094-1.095h-1.646a1.63,1.63,0,0,1-1.63-1.63v-1.646a1.1,1.1,0,0,0-1.095-1.095,1.1,1.1,0,0,0-1.095,1.095v1.646a1.63,1.63,0,0,1-1.63,1.63H948.93a1.094,1.094,0,0,0-1.094,1.095A1.094,1.094,0,0,0,948.93-485.109Z"
            transform="translate(-935.827 502.841)"
            fill="#fff"
          />
          <circle
            id="Left_Stars_1"
            cx="2.315"
            cy="2.315"
            r="2.315"
            transform="translate(0 0)"
            fill="#fff"
          />
        </g>
        <g id="Right_Stars" transform="translate(1036.37 -517.399)">
          <circle
            id="Right_Stars_2"
            cx="2.315"
            cy="2.315"
            r="2.315"
            transform="translate(18.309 0)"
            fill="#fff"
          />
          <path
            id="Right_Stars_1"
            d="M1079.6-485.109h-1.646a1.63,1.63,0,0,0-1.63,1.63v1.646a1.1,1.1,0,0,1-1.095,1.095,1.1,1.1,0,0,1-1.095-1.095v-1.646a1.63,1.63,0,0,0-1.63-1.63h-1.646a1.094,1.094,0,0,1-1.094-1.095,1.094,1.094,0,0,1,1.094-1.095h1.646a1.63,1.63,0,0,0,1.63-1.63v-1.646a1.1,1.1,0,0,1,1.095-1.095,1.1,1.1,0,0,1,1.095,1.095v1.646a1.63,1.63,0,0,0,1.63,1.63h1.646a1.094,1.094,0,0,1,1.094,1.095A1.094,1.094,0,0,1,1079.6-485.109Z"
            transform="translate(-1069.766 502.841)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'IconThumbsUp'
};
</script>

<style lang="postcss">
@import '../../styles/animate.css';
</style>
